import type { ReactNode } from 'react';
import { Overlay } from '../../Overlay/Overlay';
import '../Modal.css';

export type ModalSceneSize = 'slot' | 'text';

/** Static Storybook wrapper that centers a modal dialog over an optional overlay. */
export type ModalSceneProps = {
  showOverlay?: boolean;
  size?: ModalSceneSize;
  /** Called when the overlay backdrop is clicked. */
  onOverlayClick?: () => void;
  children: ReactNode;
};

export function ModalScene({
  showOverlay = true,
  size = 'text',
  onOverlayClick,
  children,
}: ModalSceneProps) {
  const dialogClass =
    size === 'slot' ? 'spark-modal-scene-dialog spark-modal-scene-dialog-slot' : 'spark-modal-scene-dialog';

  return (
    <div
      className={[
        'spark-modal-scene',
        showOverlay ? '' : 'spark-modal-scene--no-overlay',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {showOverlay ? (
        <div className="spark-modal-scene-overlay-hit" onClick={onOverlayClick}>
          <Overlay />
        </div>
      ) : null}
      <div className={dialogClass}>{children}</div>
    </div>
  );
}
